import M from 'messages';

const chanelMapping = {
  facebook: M.get('table.wineLover.filter.channel.facebook'),
  google: M.get('table.wineLover.filter.channel.google'),
};
const receiveMarketingEmailsMapping = {
  true: M.get('table.wineLoversActivities.filter.receiveMarketingEmails.yes'),
  false: M.get('table.wineLoversActivities.filter.receiveMarketingEmails.no'),
};
const receiveNewsEmailsMapping = {
  true: M.get('table.wineLoversActivities.filter.receiveNewsEmails.yes'),
  false: M.get('table.wineLoversActivities.filter.receiveNewsEmails.no'),
};
const receiveEventsEmailsMapping = {
  true: M.get('table.wineLoversActivities.filter.receiveEventsEmails.yes'),
  false: M.get('table.wineLoversActivities.filter.receiveEventsEmails.no'),
};
const activityTypeMapping = {
  clickedBuy: M.get('table.wineLoversActivities.filter.activityType.clickedBuy'),
  clickedMore: M.get('table.wineLoversActivities.filter.activityType.clickedMore'),
  rate: M.get('table.wineLoversActivities.filter.activityType.rate'),
  bookmark: M.get('table.wineLoversActivities.filter.activityType.bookmark'),
  unBookmark: M.get('table.wineLoversActivities.filter.activityType.unBookmark'),
  follow: M.get('table.wineLoversActivities.filter.activityType.follow'),
  unfollow: M.get('table.wineLoversActivities.filter.activityType.unfollow'),
};

const shortInterestsMapping = {
  discover: M.get('table.wineLoversActivities.interests.discover'),
  rate: M.get('table.wineLoversActivities.interests.rate'),
  save: M.get('table.wineLoversActivities.interests.save'),
  buy: M.get('table.wineLoversActivities.interests.buy'),
  offers: M.get('table.wineLoversActivities.interests.offers'),
  events: M.get('table.wineLoversActivities.interests.events'),
  learn: M.get('table.wineLoversActivities.interests.learn'),
  share: M.get('table.wineLoversActivities.interests.share'),
};

const interestsMapping = {
  discover: M.get('table.wineLoversActivities.filter.interests.discover'),
  rate: M.get('table.wineLoversActivities.filter.interests.rate'),
  save: M.get('table.wineLoversActivities.filter.interests.save'),
  buy: M.get('table.wineLoversActivities.filter.interests.buy'),
  offers: M.get('table.wineLoversActivities.filter.interests.offers'),
  events: M.get('table.wineLoversActivities.filter.interests.events'),
  learn: M.get('table.wineLoversActivities.filter.interests.learn'),
  share: M.get('table.wineLoversActivities.filter.interests.share'),
  notSet: M.get('table.wineLoversActivities.filter.interests.notSet'),
};

const channelOptions = [
  {
    value: 'facebook',
    label: chanelMapping.facebook,
    title: chanelMapping.facebook,
  },
  {
    value: 'google',
    label: chanelMapping.google,
    title: chanelMapping.google,
  },
];

const roleOptions = [
  {
    value: 'Event Organizer',
    label: M.get('table.wineLoversActivities.filter.role.eventOrganizer'),
    title: M.get('table.wineLoversActivities.filter.role.eventOrganizer'),
  },
  {
    value: 'Importer/Distributor',
    label: M.get('table.wineLoversActivities.filter.role.importerDistributor'),
    title: M.get('table.wineLoversActivities.filter.role.importerDistributor'),
  },
  {
    value: 'Retailer/Wine Shop',
    label: M.get('table.wineLoversActivities.filter.role.retailerWineShop'),
    title: M.get('table.wineLoversActivities.filter.role.retailerWineShop'),
  },
  {
    value: 'Sommelier/Restaurant',
    label: M.get('table.wineLoversActivities.filter.role.sommelierRestaurant'),
    title: M.get('table.wineLoversActivities.filter.role.sommelierRestaurant'),
  },
  {
    value: 'Wine Enthusiast',
    label: M.get('table.wineLoversActivities.filter.role.wineEnthusiast'),
    title: M.get('table.wineLoversActivities.filter.role.wineEnthusiast'),
  },
  {
    value: 'Wine Journalist/Educator',
    label: M.get('table.wineLoversActivities.filter.role.wineJournalistEducator'),
    title: M.get('table.wineLoversActivities.filter.role.wineJournalistEducator'),
  },
  {
    value: 'Winery Professional',
    label: M.get('table.wineLoversActivities.filter.role.wineryProfessional'),
    title: M.get('table.wineLoversActivities.filter.role.wineryProfessional'),
  },
  {
    value: 'Other',
    label: M.get('table.wineLoversActivities.filter.role.other'),
    title: M.get('table.wineLoversActivities.filter.role.other'),
  },
  {
    value: 'notSet',
    label: M.get('table.wineLoversActivities.filter.interests.notSet'),
    title: M.get('table.wineLoversActivities.filter.interests.notSet'),
  },
];

const interestOptions = [
  {
    value: 'events',
    label: interestsMapping.events,
    title: interestsMapping.events,
  },
  {
    value: 'discover',
    label: interestsMapping.discover,
    title: interestsMapping.discover,
  },
  {
    value: 'buy',
    label: interestsMapping.buy,
    title: interestsMapping.buy,
  },
  {
    value: 'learn',
    label: interestsMapping.learn,
    title: interestsMapping.learn,
  },
  {
    value: 'rate',
    label: interestsMapping.rate,
    title: interestsMapping.rate,
  },
  {
    value: 'offers',
    label: interestsMapping.offers,
    title: interestsMapping.offers,
  },
  {
    value: 'save',
    label: interestsMapping.save,
    title: interestsMapping.save,
  },
  {
    value: 'share',
    label: interestsMapping.share,
    title: interestsMapping.share,
  },
  {
    value: 'notSet',
    label: interestsMapping.notSet,
    title: interestsMapping.notSet,
  },
];

const registrationTypeOptions = [
  {
    value: 'Business',
    label: M.get('table.wineLoversActivities.filter.registrationType.business'),
    title: M.get('table.wineLoversActivities.filter.registrationType.business'),
  },
  {
    value: 'Individual',
    label: M.get('table.wineLoversActivities.filter.registrationType.individual'),
    title: M.get('table.wineLoversActivities.filter.registrationType.individual'),
  },
  {
    value: 'notSet',
    label: M.get('table.wineLoversActivities.filter.interests.notSet'),
    title: M.get('table.wineLoversActivities.filter.interests.notSet'),
  },
];

const activityTypeOptions = [
  {
    value: 'rate',
    label: activityTypeMapping.rate,
    title: activityTypeMapping.rate,
  },
  {
    value: 'bookmark',
    label: activityTypeMapping.bookmark,
    title: activityTypeMapping.bookmark,
  },
  {
    value: 'unBookmark',
    label: activityTypeMapping.unBookmark,
    title: activityTypeMapping.unBookmark,
  },
  {
    value: 'clickedMore',
    label: activityTypeMapping.clickedMore,
    title: activityTypeMapping.clickedMore,
  },
  {
    value: 'clickedBuy',
    label: activityTypeMapping.clickedBuy,
    title: activityTypeMapping.clickedBuy,
  },
  {
    value: 'follow',
    label: activityTypeMapping.follow,
    title: activityTypeMapping.follow,
  },
  {
    value: 'unfollow',
    label: activityTypeMapping.unfollow,
    title: activityTypeMapping.unfollow,
  },
];

const receiveMarketingEmailsOptions = [
  {
    value: 'false',
    title: receiveMarketingEmailsMapping.false,
  },
  {
    value: 'true',
    title: receiveMarketingEmailsMapping.true,
  },
];

const receiveNewsEmailsOptions = [
  {
    value: 'false',
    title: receiveNewsEmailsMapping.false,
  },
  {
    value: 'true',
    title: receiveNewsEmailsMapping.true,
  },
];

const receiveEventsEmailsOptions = [
  {
    value: 'false',
    title: receiveEventsEmailsMapping.false,
  },
  {
    value: 'true',
    title: receiveEventsEmailsMapping.true,
  },
];

const receiveMarketingEmailsOptionsForWineLovers = [
  {
    value: 0,
    title: receiveMarketingEmailsMapping.false,
  },
  {
    value: 1,
    title: receiveMarketingEmailsMapping.true,
  },
];

const receiveNewsEmailsOptionsForWineLovers = [
  {
    value: 0,
    title: receiveNewsEmailsMapping.false,
  },
  {
    value: 1,
    title: receiveNewsEmailsMapping.true,
  },
];

const receiveEventsEmailsOptionsForWineLovers = [
  {
    value: 0,
    title: receiveEventsEmailsMapping.false,
  },
  {
    value: 1,
    title: receiveEventsEmailsMapping.true,
  },
];

export {
  channelOptions,
  roleOptions,
  interestOptions,
  registrationTypeOptions,
  activityTypeOptions,
  receiveMarketingEmailsOptions,
  receiveNewsEmailsOptions,
  receiveEventsEmailsOptions,
  receiveMarketingEmailsOptionsForWineLovers,
  receiveNewsEmailsOptionsForWineLovers,
  receiveEventsEmailsOptionsForWineLovers,
  interestsMapping,
  chanelMapping,
  receiveMarketingEmailsMapping,
  receiveNewsEmailsMapping,
  receiveEventsEmailsMapping,
  activityTypeMapping,
  shortInterestsMapping,
};
